import { RecipientStatus, RequestStatus } from '@/types/types';

const translations = {
    en: {
        account: {
            annualPayment: 'Annual Payment (-20%)',
            businessPlan: 'Business Plan',
            canceled: 'canceled',
            checkEmail: 'Please check your email address',
            comparePlans: 'Compare plans',
            DeleteAccount: 'Delete Account',
            deleteConfirmationTitle: 'Please confirm your account deletion',
            emailChangeConfirmation: 'Confirm the email change',
            emailChangeConfirmationMessage:
                'After confirmation you will be logged out and will receive a verification email at the new email address.',
            emailVerificationFailed: 'Email verification has failed.',
            emailVerificationFailedTitle: 'Verification failed',
            emailVerificationExpired:
                'The verification link has expired. Please go to "My Account" and resend the verification email.',
            emailVerificationExpiredTitle: 'This link has expired',
            emailVerificationSuccess:
                'Your email address has been successfully verified!',
            emailVerificationSuccessTitle: 'Email address verified',
            emailVerificationSuccessPill: 'Your account is now fully activated',
            emailVerificationInProgressTitle: 'Verifying your email address',
            emailVerificationInProgressMessage:
                'This will only take a moment. Please do not close this window.',
            emailChangeFailed: 'Email change confirmation failed.',
            emailChangeExpired:
                'The email change confirmation link has expired. Please request a new email change from your account settings.',
            emailChangeExpiredTitle: 'This link has expired',
            emailChangeSuccess: 'Email changed successfully.',
            resendVerification: 'Resend',
            verificationEmailSent: 'Verification email sent successfully!',
            changeEmail: 'Change email',
            newEmailPlaceholder: 'Enter your new email',
            sendEmailChangeConfirmation: 'Send verification',
            verificationEmailError: 'Failed to send verification email',
            free: 'free',
            month: 'month',
            monthlyPayment: 'Monthly payment',
            planUpdateSuccess: 'Successfully updated.',
            resetPaswordTitle: 'Reset password',
            saveSuccess: 'Successfully saved.',
            trialText: '14 days trial period',
            noVatText: 'plus VAT',
            notificationsInfo:
                'Enable or disable your email notifications for various events such as document completion confirmations.',
            consentInfo:
                'Enable or disable the consent screen that signers see before viewing and signing a document.',
            validTo: 'valid to',
            renewsOn: 'renews on',
            year: 'year',
            Seats: 'Seats',
            pendingSeat: 'Pending confirmation...',
            reloadSeatStatus: 'Refresh invitation status',
            completedSeat: 'Completed',
            seatInvited: 'Invitation successfully sent!',
            seatDeleted: 'Seat has been deleted!',
            teamDeleted: 'Team has been deleted!',
            teamUpdated: 'Team has been updated!',
            confirmSeatDeletion: 'Are you sure you want to delete this user?',
            confirmTeamDeletion: 'Are you sure you want to delete this team?',
            RegisteredUserEmail: 'Already registered email address...',
            seatsInfo:
                'You can allocate available seats to other users by invitation. Users must be registered and must accept your invitation.',
            signatureInfo:
                'This signature will become your default signature selection when signing a document. If needed it can be changed when signing.',
            seatInviteAcceptConfirmation:
                'Please confirm the invitation acceptance',
            seatInviteAcceptDeclineConfirmation:
                'Please confirm the invitation decline',
            invitedBy: 'invited by',
            Teams: 'Teams',
            teamsInfo:
                'Sent documents and templates are shared among team members. Only users who have accepted your seat invitation can be added to a team.',
            memberTeamsTooltip:
                'Documents sent by members of the teams you belong to will be visible to the entire team, unless the option to not share with the team is checked when sending a signing request.',
            teamNewRequestNotif: 'Document Sent Notification',
            teamNewRequestNotifTooltip:
                'You will receive an email each time another member of this team sends a new signing request that is shared with the team.',
            teamNotifUpdated: 'Team notification settings updated!',
            PlanInfo:
                'If you want to purchase licenses for multiple users within your company, adjust the "Quantity" field at checkout to reflect the total number of users who will have access to the platform. After completing the payment, you will be able to manage licenses and invite colleagues directly from your account.',
            unverified: 'unverified',
            EmailNotVerified: 'Not available: Unverified email address',
            DisableMFAConfirmation:
                'You are disabling 2FA. You will be logged out and will need to login again.',
            TwoFAConfigTitle: '2FA configuration',
            PhoneNumber: 'Phone number',
            ReenterPassword: 'Reenter password',
            InputPhoneNumber: 'Mobile phone number...',
            SMSCodeTitle: 'SMS Code',
            SMSCodePh: 'Type in the code...',
            twoFaTooltip:
                'For increased security you can enable SMS two-factor authentication',
            apiConfirmation: 'Enable only if you develop an API integration',
            SigTypes: 'Sign modes',
            SigTypesInfo:
                'Select the types of signatures that will be available to the signers.',
            NoSeatsForTeam:
                "You don't have any occupied seats, so you cannot create teams. Please add at least one user.",
            packageInfo: 'Package Information',
            packageType: 'Package Type',
            startDate: 'Start Date',
            endDate: 'End Date',
            totalRequests: 'Total Requests',
            usageOverview: 'Usage Overview',
            totalRequestsSent: 'Total Requests Sent',
            userMonthlyStats: 'User Statistics',
            requests: 'requests',
            noEnterprisePackage: 'No enterprise package available',
            Permissions: 'Permissions',
            hasAdminViewPermissions:
                'View all organization documents permissions',
            Analytics: 'Analytics',
            ReportsTitle: 'Reports',
            reportsInfo:
                'Statistics for the documents you sent for signing in the selected period.',
            viewReports: 'View reports for your sent documents',
            exportCsv: 'Export CSV',
            csvMaxRange: 'CSV export is available for up to 3 months',
            reportMaxRange: 'Select a range of at most 1 year',
            reportsRateLimited:
                'Too many report requests. Please wait a minute and try again.',
            csvRateLimited:
                'You can export once per minute. Please try again shortly.',
            noReportData: 'No documents were sent in the selected period',
            reportSent: 'Sent',
            reportCompleted: 'Completed',
            reportInProgress: 'In progress',
            reportRejected: 'Rejected',
            reportCanceled: 'Canceled',
            completionRate: 'Completion rate',
            activity: 'Activity',
            timeToComplete: 'Time to complete',
            average: 'Average',
            median: 'Median',
            signersTitle: 'Signers',
            signersTotal: 'Total',
            signersSigned: 'Signed',
            signersPending: 'Pending',
            signersRejected: 'Rejected',
            bySource: 'By source',
            topRecipients: 'Top signers',
            topTags: 'Top tags',
            noPasswordEmailTitle: 'Change email',
            noPasswordEmailMessage:
                'To change your email address you first need to set a password. Click Confirm to sign out and go to the password reset page. After setting a password, log back in and change your email from here.',
        },
        api: {
            Docs: 'Docs',
            ApiDocumentation: 'API Documentation',
            LlmPromptTitle: 'Using an LLM?',
            LlmPromptDescription: 'Download and use the API schema directly.',
            DownloadApiSchema: 'Download API schema',
            Usage: 'Usage',
            BuyApiCredits: 'Buy API Credits',
            ValidTo: 'Valid to',
            ApiKeys: 'API Keys',
            NotificationEmail: 'Notification Email',
            NotificationEmailPlaceholder:
                'Additional email for usage notifications (optional)',
            WebhookUrl: 'Webhook URL',
            WebhookEvents: 'Events',
            HeaderName: 'Header Name',
            HeaderValue: 'Header Value',
            RevokeApiKey: 'Revoke',
            RegenerateApiKey: 'Regenerate',
            RevokeConfirmation:
                'Are you sure you want to revoke your API key? All requests using this key will stop working immediately.',
            RegenerateConfirmation:
                'Are you sure you want to regenerate your API key? The current key will be revoked and a new one will be issued.',
            ApiKeyRevoked: 'API key revoked successfully.',
            ApiKeyRegenerated: 'API key regenerated successfully.',
            ApiKeyGenerated: 'API key generated successfully.',
            NoApiKey: 'No active API key.',
            ShowKey: 'Show',
            HideKey: 'Hide',
            CopyKeyWarning:
                'Copy this key now. You will not be able to see it again.',
            KeyNamePlaceholder: 'Key name...',
            GenerateNewKey: 'Generate',
            MaxKeysReached: 'Maximum number of API keys reached (5).',
            Credits: 'Credits',
            credits: 'credits',
            Consumption: 'Consumption',
            ShowMonthlyConsumption: 'Show monthly consumption',
            HideMonthlyConsumption: 'Hide monthly consumption',
            NoMonthlyConsumption: 'No monthly API usage yet.',
            available: 'available',
            untilMonthEnd: 'until the end of the month',
            AutoRefill: 'Auto refill',
            EnableAutoRefill: 'Enable auto refill',
            AutoRefillThresholdPlaceholder:
                'Refill when credits drop below this value',
            AutoRefillQuantityPlaceholder:
                'Number of credits to buy on each refill',
            AutoRefillThresholdError: 'Must be a number > 0',
            AutoRefillQuantityError: 'Must be a number ≥ 1',
        },
        auth: {
            alreadyRegisteredQ: 'Already registered?',
            emailAddress: 'Email address',
            emailInUse: 'Email already registered',
            forgotPasswordQ: 'Forgot password?',
            inputEmailAddress: 'Type your email address...',
            inputName: 'Company or person...',
            inputPassword: 'Type your password...',
            login: 'Login',
            loginWithGoogle: 'Login with Google',
            loginWithMSF: 'Login with Microsoft',
            name: 'Name',
            notRegisteredQ: 'Not registered?',
            password: 'Password',
            passwordComplexity: 'Minimum 8 characters',
            register: 'Sign up',
            registerTitle: 'Try {{app}} free!',
            registerSubTitle:
                'eSign or collect signatures in seconds. 3 documents/month included.',
            registerTitleApiDev: 'Build with {{app}} API',
            registerSubTitleApiDev:
                'Create an API development account with API access. Intended for reasonable unlimited development and testing usage. Documents are watermarked.',
            loginTitle: 'Login to {{app}}',
            loginSubTitle: 'eSign or collect signatures in seconds',
            registerWithGoogle: 'Sign up with Google',
            registerWithMSF: 'Sign up with Microsoft',
            tos: 'Terms and Conditions',
            tosMessage: 'By signing up you agree with our',
            wrongEmailOrPasswords: 'Incorrect email or password',
            allRightsReserved: 'All rights reserved',
            footerMessage: 'Any questions? Contact us!',
        },
        bulk: {
            Completed: 'Completed',
            completedTable: 'Completed table',
            completedTableTootlip:
                'This file contains the signers email addresses.',
            createSuccess: 'Succesfully created!',
            csvError: 'Extract error!',
            csvSuccess:
                'Csv file successfully processed! {{number}} valid sign requests',
            Date: 'Date',
            errorRows: 'Error rows',
            errorRowsTooltip:
                'Double check the email address format and whether there are duplicates on a row.',
            fileTypeErr: 'File type must be .csv',
            instructions: 'Instructions',
            instructionsIntro:
                'Bulk send allows sending the same document to multiple recipients with a single operation. Instead of manually inputing all email addresses with each template use, with bulk send you can upload a csv file.',
            instructionsStep1: `Step 1: Download the below provided table header. Each column corresponds to a signer defined in the template.`,
            instructionsStep2: `Step 2: Fill in the .csv file with the signer's email addresses and save it as .csv (you may use tools like Google Sheets). Each row will generate a separate sign request.`,
            instructionsStep3: `Step 3: Upload the the completed .csv file.`,
            instructionsStep4: `Step 4: Send. The generated sign requests will appear progresively in the Send Documents list.`,
            pageTitle: 'Bulk send',
            Sent: 'Sent',
            sentPageTitle: 'Bulk sent',
            tableHeader: 'Table header',
            tableHeaderTootltip:
                'This files contains the table header and need to be filled in with the signers email addresses.',
            Total: 'Standalone requests',
            uploadCompletedTable: 'Upload the completed table.',
            uploadCsvFile: 'Upload .csv file',
            validRows: 'Valid rows',
            validRowsTootlip:
                'Each row will generate an individual sign request.',
        },
        buttons: {
            add: 'Add',
            Back: 'Back',
            backCancel: 'Cancel',
            cancel: 'Cancel',
            cancelRequest: 'Cancel request',
            delete: 'Delete',
            download: 'Download',
            downloadCertificate: 'Download Certificate',
            DownloadDocument: 'Download Document',
            edit: 'Edit',
            extract: 'Extract',
            manage: 'Manage',
            newSignRequest: 'New Sign Request',
            save: 'Save',
            send: 'Send',
            sendBulk: 'Bulk send',
            sign: 'Sign',
            use: 'Use',
            Invite: 'Invite',
            Accept: 'Accept',
            Decline: 'Decline',
            CreateNewTeam: 'Create New Team',
            Setup: 'Setup',
            Disable: 'Disable',
            SendCode: 'Send code',
            Remind: 'Remind',
        },
        common: {
            Account: 'Account',
            Cancel: 'Cancel',
            checkbox: 'checkbox',
            Checkbox: 'Checkbox',
            checkboxes: 'checkboxes',
            FileAttachment: 'File',
            fileAttachment: 'file',
            fileAttachments: 'files',
            Textarea: 'Paragraph',
            textarea: 'paragraph',
            Textareas: 'Paragraphs',
            textareas: 'paragraphs',
            Date: 'Date',
            date: 'date',
            Dates: 'Dates',
            dates: 'dates',
            Completed: 'Completed',
            Close: 'Close',
            Confirm: 'Confirm',
            DefaultSignature: 'Default signature',
            Document: 'Document',
            Documents: 'Documents',
            pagesCount_one: '{{count}} page',
            pagesCount_few: '{{count}} pages',
            pagesCount_other: '{{count}} pages',
            Fields: 'Fields',
            genericError:
                'Oops, there was an error. We have been notified about it.',
            InProgress: 'In progress',
            mandatory: 'mandatory',
            Mandatory: 'Mandatory',
            Group: 'Group',
            GroupID: 'Group ID',
            Initials: 'Initials',
            initials: 'initials',
            No: 'No',
            onlyWithBusinessPlan: 'Available only with a Business plan.',
            Options: 'Options',
            Sentby: 'Sent by',
            SentBy: 'Sent By',
            CreatedBy: 'Created by',
            signature: 'signature',
            Signature: 'Signature',
            signatures: 'signatures',
            Signer: 'Signer',
            Signers: 'Signers',
            stamp: 'stamp',
            Stamp: 'Stamp',
            stamps: 'stamps',
            Status: 'Status',
            Tags: 'Tags',
            text: 'text',
            Text: 'Text',
            texts: 'texts',
            Yes: 'Yes',
            Enable: 'Enable',
            Enabled: 'Enabled',
            Error: 'Error',
            Disabled: 'Disabled',
            UpdateSuccess: 'Succesfully updated!',
            Copy: 'Copy',
            Copied: 'Copied',
            SingLinkCopySuccess: 'Sing link has been successfully copied!',
            ApiKeyCopySuccess: 'API key has been successfully copied!',
            Reason: 'Reason',
            Updated: 'Updated',
            FontSize: 'Font size',
            Certificate: 'Certificate',
            More: 'More',
            Notifications: 'Notifications',
            Consent: 'Consent screen',
            Radio: 'Radio',
            Members: 'Members',
            You: 'you',
            Name: 'Name',
            selected: 'selected',
            Fixed: 'Fixed',
            Reload: 'Reload',
            Continue: 'Continue',
            Seen: 'Seen',
            Signed: 'Signed',
            signedSuffix: 'signed',
            Rejected: 'Rejected',
            Downloaded: 'Downloaded',
        },
        createSR: {
            addSigner: 'Add signer',
            converting: 'Converting to PDF...',
            merging: 'Merging documents...',
            duplicateEmail: 'Duplicate email',
            duplicateNumber: 'Duplicate number',
            emailAddPh: 'Add message',
            emailRecipientPh: 'Email address...',
            emailTitle: 'Message (optional)',
            emailTitleTooltip: 'You may add a custom email message to signers.',
            emailSubject: 'Email subject (optional)',
            emailSubjectTooltip:
                'You may add a custom email subject to signers. If not set, the default subject will be used.',
            extractTagsSuccess: '{{fieldsCount}} fields have been extracted!',
            extractTagsZero:
                'No field found! Make sure you have tags like {{s:1}} or {{t:1____ }}',
            fieldsMessage:
                'You have {{signaturesFieldsCount}} signatures, {{stampFieldsCount}} stamps and {{textFieldsCount}} text fields.',
            fieldsMessagePrefix: 'You have',
            fieldsMinSignersErr: 'You must fill in at least one signer',
            fieldsTitle: 'Signatures and other fields (optional)',
            fieldsTitleTooltip:
                'You can indicate to signers the places on the document where they need to sign or fill in various information. Additionally, you can automatically extract fields by adding certain tags in the document text. These tags can be white in color to remain invisible. For example, the tag “{{s:1}}” represents a signature for the first signer, “{{s:2}}” for the second signer, and so on. To make a field required, add the letter “r” at the end of the tag, e.g., “{{s:1}}r”. To lock a field position, add the letter “f”, e.g., “{{s:1}}f”. Flags can be combined, e.g., “{{s:1}}rf”. Other possible tags: “{{t:1____}}” for text fields, “{{c:1}}” for a checkbox, or “{{c:1:1}}” for checkbox groups, where the second number in the tag represents the group number. A required checkbox group will force the signer to select at least one option. To make a checkbox group behave as a radio group (only one option selectable at a time), add the letter “o” at the end, e.g., “{{c:1:1}}o”. Additionally, signers can be extracted using tags like: {{r:1:e:email@example.com}}. They can be of white colour.',
            fileSizeErr: 'File size is over the max allowed size of',
            fileTypeErr: 'File must be pdf, doc or docx',
            incorectEmail: 'Incorrect email',
            incorectNumber: 'Incorrect number',
            isCopyOnly: 'Send a copy only',
            isCopyOnlyTooltip:
                'This recipient only gets a copy of the signed document without signing it.',
            leftChars: 'left characters',
            templates: 'Templates',
            emailTemplatesSubject: 'Email Subject Templates',
            emailTemplatesMessage: 'Email Message Templates',
            myTemplates: 'My Templates',
            teamTemplates: 'Team Templates',
            noTemplates: 'No saved templates yet.',
            saveCurrentAsTemplate: 'Save current as template',
            noContentToSave: 'Type something first to save it as a template',
            shareWithTeams: 'Share with teams',
            MinNameChars: 'Minimum {{number}} characters',
            moreSignerWithBusiness:
                'More recipients available with the Busines plan.',
            noFieldsMessage: 'You have no fields.',
            oneClickSign: 'Sign with one click',
            advancedSignature: 'Advanced signature',
            optVerification: 'SMS verification',
            optVerificationTooltip:
                'In addition to email validation, the signer will also be asked to verify their mobile phone number using an OTP code sent by SMS.',
            oneClickSignTooltip:
                'Used in conjunction with SMS and positioning a signature on the document. Signer will only need to click once on the signature field and the signature will be filled with its name',
            EnglishLanguage: 'English language',
            SignLinkOnly: 'Sign link only',
            SignLinkOnlyTootlip:
                'Only generate the unique signing link. You may use this option if you need to send the signing link yourself through other channels or the person signs at the same computer. After sending the sign request, open the details window and you can find the unique signing link.',
            SendBySMS: 'SMS',
            EnglishLanguageTooltip:
                'Notification emails and the signing page will be in the english language',
            prefillInfoBubble1:
                'On this page you can prefill the document with various text data.',
            prefillInfoBubble2:
                'The text data added here will be premanently applied on the document once sent and can not be edited later.',
            prefillMessage: 'You have added {{number}} texts.',
            prefillPageTitle: 'Prefill document',
            prefillTitle: 'Prefill data (optional)',
            prefillTitleTootlip:
                'You may fill or add data on the document before being sent to the signers.',
            SelectSigner: 'Select signer',
            sentSuccess: 'Successfully sent!',
            SignerNamePh: 'Name...',
            signInOrder: 'Sign in order',
            signInOrderTooltip:
                'Signers will be notified only after the previous one has signed.',
            signMySelf: 'I am also signing',
            signMyselfTooltip:
                'You will also be added to the signer list and you will be able to sign after sending the request.',
            smsNotifOption: 'Send through SMS',
            smsNotifOptionTooltip:
                'This signer will get the secure signing link through SMS.',
            tagsAddPh: 'Add one or more tags...',
            tagsTitle: 'Tags (optional)',
            tagsTitleTooltip:
                'You may use tags to categorize your sign requests.',
            templateRecipientPh: 'Role, name, etc...',
            templateSaveSuccess: 'Successfully saved!',
            uploadDoc: 'Upload a document',
            uploadErr: 'File upload error.',
            mergedFileTooLarge:
                'The merged document would exceed 5MB. Please add a smaller file.',
            uploadFile: 'Upload file',
            addFile: 'Add file',
            dragToReorder: 'Drag to reorder',
            mainDocument: 'Main document',
            additionalDocuments: 'Additional documents',
            additionalDocumentsTooltip:
                'These documents are sent within the same sign request. Once the request is completed, each document can be downloaded separately.',
            pickFromDrive: 'Google Drive',
            driveDownloading: 'Downloading from Google Drive...',
            driveErr: 'Could not import the file from Google Drive.',
            driveAuthErr:
                'Google Drive access was not granted. Please try again and allow access.',
            verifyEmail:
                'Please verify your email address in order to send more sign requests.',
            freePlanMonthlyLimitReached:
                'Free plan limit reached: you can send up to 3 documents per month. Upgrade to continue.',
            hideFromTeam: 'Do NOT share with team',
            hideFromTeamTooltip:
                'The document will not be visible to other team members.',
        },
        editFields: {
            fieldLabel: 'Label (optional)',
            textFieldDescriptionPh: 'E.g. Name, Address, etc...',
            fileAttachFieldDescriptionPh: 'E.g. ID, Certificate, etc...',
            howToDrag: 'Hold and drag the field on to the document',
            infoBubble1:
                'Fields added on the document will be visualised and filled by signers.',
            infoBubble2:
                'After adding a field you will have to select the signer.',
            infoBubble3: 'You have added {{fieldModeFieldsCount}} fields.',
            infoBubble4:
                'All fields have recipients assigned. You may save them.',
            infoBubble5:
                '{{noRecipientFieldsCount}} fields dont have a signer assigned.',
            infoBubble6:
                'Drag and drop the field on the document. Assign the signer from the right panel.',
            infoBubble7:
                'Signer will not be able to complete signing without filling this field.',
            infoBubble8:
                'This field can only be seen and filled by the selected signer.',
            infoBubble9:
                'A short description can indicate the signer what to fill in.',
            infoBubble10:
                ' A required checkbox group will force the signer to select at least one option.',
            infoBubble11:
                ' A radio group will allow the signer to select only one option from the group.',
            infoBubble12:
                'A fixed field cannot be moved or resized by the signer.',
            inputTextPh: 'Add text...',
            noSignerFields: 'You have fields without a signer',
            title: 'Add and edit fields',
        },
        homePage: {
            subTitle: 'Sent and received documents summary',
        },
        menu: {
            account: 'ACCOUNT',
            bulkSent: 'Bulk Requests',
            contact: 'Contact',
            free: 'free',
            home: 'Home',
            logout: 'Logout',
            myAccount: 'My Account',
            newRequest: 'New Sign Request',
            personalPlan: 'Personal Plan',
            receivedRequests: 'Received Requests',
            reports: 'Reports',
            sentDocs: 'Sent Documents',
            templates: 'Templates',
            upgrade: 'UPGRADE',
            userGuide: 'User Guide',
        },
        recipientStatus: {
            [RecipientStatus.SIGNED]: 'Signed',
            [RecipientStatus.PENDING]: 'Pending',
            [RecipientStatus.NEXT]: 'Next',
            [RecipientStatus.WAITING]: 'Waiting',
            [RecipientStatus.SIG_RECEIVED]: 'Processing',
            [RecipientStatus.SMS_ERROR]: 'SMS Error',
            [RecipientStatus.REJECTED]: 'Declined',
        },
        recipientStatusTitle: {
            [RecipientStatus.SIGNED]: 'Recipient has signed.',
            [RecipientStatus.PENDING]: 'Recipient has not yet signed.',
            [RecipientStatus.NEXT]: 'eEcipient is next for signing.',
            [RecipientStatus.WAITING]: 'Recipient waits for its turn.',
            [RecipientStatus.SIG_RECEIVED]: 'Processing.',
            [RecipientStatus.SMS_ERROR]: 'SMS sending error.',
            [RecipientStatus.REJECTED]: 'Signer has declined.',
        },
        requestDetails: {
            additionalFiles: 'Additional Files',
            FileAttachments: 'Signer attachments',
            completedDate: 'Completed Date',
            copyOnlySigners: 'Copy only recipients',
            Loading: 'Loading...',
            NotYetPossible: 'Not yet possible',
            reminder: 'Reminder',
            reminderSuccessMessage: 'Notification successfully sent!',
            Send: 'Send now',
            sentBy: 'Sent by',
            sentDate: 'Sent Date',
            SuccessfullySent: 'Successfully sent',
            tooltipMessage1: 'You can send a reminder every day.',
            tooltipMessage2:
                'These recipients will receive copies of signed documents.',
            cancelConfirmation: 'Please confirm the sign request cancelation',
            deleteConfirmation: 'Please confirm the sign request deletion',
        },
        requestsListPage: {
            Details: 'Details',
            Document: 'Document',
            mainButtonTitleRequest: 'New sign request',
            mainButtonTitleTemplate: 'New template',
            No: 'No',
            noRequestFound: 'No sign request found.',
            noTemplateFound: 'No template found.',
            SentDate: 'Sent date',
            Sign: 'Sign',
            Status: 'Status',
            templateInfoText: `Templates allow saving and reusing a sign request.`,
            Waiting: 'Waiting',
            YouSigned: 'You signed',
            TemplateDeleteConfirmation: 'Please confirm the template delete',
            RemindersSent: 'Reminders sent',
            ConfirmUpdateRecipient: 'Please confirm recipient change',
        },
        requestStatus: {
            [RequestStatus.COMPLETED]: 'Completed',
            [RequestStatus.IN_PROGRESS]: 'In Progress',
            [RequestStatus.PROCESSING]: 'Processing',
            [RequestStatus.PREFILLING]: 'Processing',
            [RequestStatus.CANCELED]: 'Canceled',
            [RequestStatus.TEMPLATE]: 'Template',
            [RequestStatus.REJECTED]: 'Declined',
        },
        requestStatusTitle: {
            [RequestStatus.COMPLETED]: 'All signers have signed.',
            [RequestStatus.IN_PROGRESS]: 'Waiting for signers to sign.',
            [RequestStatus.PROCESSING]: 'Check status in a few minutes.',
            [RequestStatus.PREFILLING]: 'Check status in a few minutes.',
            [RequestStatus.CANCELED]: 'Sign request has been canceled.',
            [RequestStatus.TEMPLATE]: 'Template',
            [RequestStatus.REJECTED]: 'Sign request has been declined.',
        },
        routes: {
            AccountPageTitle: 'My account',
            AccountRoute: '/account',
            ApiPageTitle: 'API Settings',
            ApiRoute: '/api-config',
            BulkSendCreatePageTitle: 'Create bulk sign request',
            BulkSendCreateRoute: '/bulk/create',
            BulkSentPageTitle: 'Bulk sent requests',
            BulkSentRoute: '/bulk',
            CreateFromTemplatePageTitle: 'Create from template',
            CreateFromTemplateRoute: '/requests/from-template',
            CreateRequestPageTitle: 'Create new sign request',
            CreateRequestRoute: '/requests/new',
            CreateTemplate: '/templates/new',
            CreateTemplatePageTitle: 'Create template',
            CreateTemplateRoute: '/templates/new',
            EditFieldsPageTitle: 'Edit fields',
            EditFieldsRoute: '/requests/new/fields',
            EditTemplatePageTitle: 'Edit template',
            EditTemplateRoute: '/templates/edit',
            EmailVerificationPageTitle: 'Email verification',
            EmailVerificationRoute: '/email/verify',
            EmailChangeConfirmationPageTitle: 'Email change confirmation',
            EmailChangeConfirmationRoute: '/email/change-confirm',
            HomePageTitle: 'Home',
            HomeRoute: '/home',
            LoginPageTitle: 'Login',
            LoginRoute: '/login',
            PreFillDocumentPageTitle: 'Pre-fill document',
            PreFillDocumentRoute: '/requests/new/prefill',
            ReceivedRequestsPageTitle: 'Received sign requests',
            ReceivedRequestsRoute: '/requests/received',
            ReportsPageTitle: 'Reports',
            ReportsRoute: '/reports',
            ResetPasswordPageTitle: 'Password reset',
            ResetPasswordRoute: '/password-reset',
            SentRequestsPageTitle: 'Sent documents',
            SentRequestsRoute: '/requests/sent',
            SignErrorPageTitle: 'Sign error',
            SignErrorRoute: '/sign-error',
            SignPageTitle: 'Sign',
            SignRoute: '/sign',
            SignSuccessPageTitle: 'Successfully signed',
            SignSuccessRoute: '/sign-succes',
            SignupPageTitle: 'Sign Up',
            SignupRoute: '/signup',
            SuperRoute: '/super',
            TemplatesPageTitle: 'Templates',
            TemplatesRoute: '/templates',
            CompletedDocumentRoute: '/document/completed',
            CompletedDocumentPageTitle: 'Signed document download',
        },
        search: {
            searchPh: 'Search documents...',
            selectFilters: 'Select filters...',
            selectTimeRange: 'Select time range...',
            typeToSearch: 'Type to search...',
            noResults: 'No results',
        },
        sign: {
            AlreadySigned: 'You have already signed.',
            andFill: 'and fill {{nonSigsCount}} fields',
            Check: 'Check',
            closeWindow: 'You may close the window now.',
            createAccount: 'Create account',
            createAccountCTA:
                'Create an account so you can track all your signed documents.',
            docHasBeenSigned: 'The document has been signed',
            docSentByEmail: `The completed document will be sent to your email address. With a free account you can track all your signed documents.`,
            Draw: 'Draw',
            Generator: 'Generator',
            error: 'error',
            errorEncountered: 'There was an',
            extraFields: 'Extra fields',
            DeclinedErr: 'The sign request has been declined.',
            EmailNotVerifiedErr:
                'Please verify your email address to be allowed to sign.',
            LinkExpired:
                'The sign link has expired. Please contact the document sender to resend the sign request.',
            GoToField: 'Go to field',
            imageFileErr: 'The image must be png, jpg or jpeg.',
            fileSizeErr: 'The file is over the max size of {{maxMB}}MB.',
            fileAttachExtErr: 'File must be a document type, image or zip',
            infoBubble1: 'Touch the highlighted area to sign.',
            infoBubble2: 'Drag and drop the field directly on the document.',
            infoBubble3: 'Click on the highlighted area to sign or fill.',
            InputName: 'Name...',
            InputText: 'Text...',
            InvalidSigner: 'You dont have the right to sign this document.',
            NotFound: 'Sign request not found.',
            RequestCanceled: 'Sign request has been canceled.',
            RequestCompleted: 'Sign request has already been completed.',
            Reset: 'Reset',
            SeeDetails: 'Details',
            select: 'Select',
            SignerNotNext: 'Please wait for your turn.',
            signSuccess: 'You have successfully signed!.',
            signDecline: 'The sign request hs been declined.',
            signSuccessMessage:
                'The completed document will be sent to your email address or by SMS.',
            signSuccessMessage2: ' Create an account or find out more on',
            sigTitle: 'Select signature type',
            fileAttachmentTitle: 'Upload a file',
            successfully: 'successfully',
            textTitle: 'Add text',
            UnCheck: 'UnCheck',
            Uploadimage: 'Upload image',
            youHaveToSign: 'You have to sign in {{sigsCount}} place(s)',
            reviewAndComplete:
                'Please review the document below and complete the highlighted fields.',
            requiredProgress:
                '{{completed}} of {{total}} required fields completed',
            allRequiredDone:
                'All required fields are completed. Click "{{action}}" to finish.',
            Start: 'Start',
            Next: 'Next',
            TagSign: 'Sign',
            TagFill: 'Fill in',
            TagDate: 'Date',
            TagCheck: 'Check',
            TagUpload: 'Upload',
            SignHere: 'Sign here',
            DeclineConfirmation: 'Please add the decline reason and confirm',
            OtpVerifiedNumber: 'Verified phone number',
            OtpVerifiedRecipientsTitle: 'SMS Verified Signers',
            DrawHint: 'Draw your signature above',
            OtpModalTitle: 'Additional verification',
            OtpModalSubtitle:
                'The document issuer has requested additional verification for the signer. Please enter your mobile phone number and validate the OTP code received via SMS or WhatsApp.',
            OtpModalSubtitlePresetNumber:
                'The document issuer has requested additional verification for the signer and pre-set your mobile number. Please validate the OTP code received via SMS or WhatsApp.',
            OtpSendCode: 'Send OTP code',
            OtpSmsCode: 'SMS Code',
            OtpWhatsappCode: 'WhatsApp Code',
            OtpChannelLabel: 'Send code via',
            OtpChannelSms: 'SMS',
            OtpChannelWhatsapp: 'WhatsApp',
            OtpSendError: 'OTP send error!',
            OtpVerifyError: 'OTP code verification error!',
            OtpExpiredError:
                'The OTP code has expired. Please request a new code.',
            OtpMaxAttemptsError:
                'Too many failed attempts. Please request a new code.',
            OtpInvalidCodeError:
                'The code you entered is incorrect. {{remaining}} attempts remaining.',
            OtpRateLimitError:
                'Too many requests. Please wait a moment and try again.',
            OtpSessionExpiredError:
                'Your signing session has expired. Please reload the page.',
            sessionExpired:
                'Your signing session has expired. Please reload the page to start a new session.',
            consentAgree: 'I agree to the',
            ConsentTitle: 'You will now view and be able to sign the document ',
            termsAndConditions: 'Terms and Conditions',
        },
        summary: {
            noReceivedRequest: 'No sign request received.',
            noSentRequest: 'Have your documents signed, simple and quickly.',
            receivedTitle: 'Received requests summary',
            secondaryTitle: 'See details',
            sentTitle: 'Sent documents summary',
            verifyEmail: 'Please verify your email address.',
        },
        other: {
            completedDocumentTitle: 'Completed document download',
            completedDocumentSubTitle:
                'Document has been succesfully signed and can be downloaded here:',
            linkExpired: 'Link expired!',
            linkExpiredMessage:
                'The download link has expired. Please request the document from the sender or create an account.',
            documentLoadError: 'Error loading document',
            documentDownloadError: 'Document download error',
            certificateDownloadError: 'Certificate download error',
        },
    },
    ro: {
        account: {
            annualPayment: 'Plată anuală (-20%)',
            businessPlan: 'Plan Business',
            canceled: 'anulat',
            checkEmail: 'Verificați-vă adresa de email',
            comparePlans: 'Compară planurile',
            DeleteAccount: 'Închide Contul',
            deleteConfirmationTitle: 'Vă rugăm confirmați ștergerea contului',
            emailChangeConfirmation: 'Confirmați schimbarea adresei de email',
            emailChangeConfirmationMessage:
                'Dupa confirmare veți fi delogat automat și veți primi un email de verificare la noua adresă de email.',
            emailVerificationFailed: 'Verificarea adresei de email a eșuat.',
            emailVerificationFailedTitle: 'Verificare eșuată',
            emailVerificationExpired:
                'Link-ul de verificare a expirat. Accesați "Contul meu" și retrimiteți email-ul de confirmare.',
            emailVerificationExpiredTitle: 'Acest link a expirat',
            emailVerificationSuccess:
                'Adresa dvs. de email a fost verificată cu succes.',
            emailVerificationSuccessTitle: 'Adresă de email verificată',
            emailVerificationSuccessPill:
                'Contul dvs. este acum complet activat',
            emailVerificationInProgressTitle:
                'Se verifică adresa dvs. de email',
            emailVerificationInProgressMessage:
                'Durează doar câteva momente. Vă rugăm să nu închideți această fereastră.',
            emailChangeFailed:
                'Confirmarea schimbării adresei de email a eșuat.',
            emailChangeExpired:
                'Link-ul pentru confirmarea schimbării adresei de email a expirat. Solicitați o nouă schimbare de email din setările contului.',
            emailChangeExpiredTitle: 'Acest link a expirat',
            emailChangeSuccess: 'Adresa de email a fost schimbată cu succes.',
            resendVerification: 'Retrimite',
            verificationEmailSent:
                'Email-ul de verificare a fost trimis cu succes!',
            changeEmail: 'Schimbă emailul',
            newEmailPlaceholder: 'Introdu noua adresă de email',
            sendEmailChangeConfirmation: 'Trimite verificarea',
            verificationEmailError:
                'Trimiterea email-ului de verificare a eșuat',
            free: 'gratuit',
            month: 'lună',
            monthlyPayment: 'Plată lunară',
            planUpdateSuccess: 'Planul a fost actualizat cu success.',
            resetPaswordTitle: 'Resetează parola',
            saveSuccess: 'Modificările au fost salvate cu succes.',
            trialText: 'primele 14 zile gratuite',
            noVatText: 'fără TVA',
            notificationsInfo:
                'Activati sau dezactivati notificările pe care le primiti pe email-ul contului pentru diferite evenimente cum ar fi confirmările de finalizare documente.',
            consentInfo:
                'Consimțământ semnare electronică. Ecran de consimțământ privind luarea la cunoștință a efectelor juridice ale semnării electronice, pe care semnatarii îl văd înainte de a vizualiza și semna un document. Pentru documente sensibile, vă recomandăm să nu dezactivați acest ecran, pentru a adăuga un plus de forță probatorie. Acest ecran este afișat aceluiași semnatar o dată la șase luni.',
            validTo: 'valabil până la',
            renewsOn: 'se reînnoiește la',
            year: 'an',
            Seats: 'Scaune',
            pendingSeat: 'Se așteaptă confirmarea...',
            reloadSeatStatus: 'Reîmprospătează statusul invitației',
            completedSeat: 'Finalizat',
            seatInvited: 'Invitatie trimisa cu succes!',
            seatDeleted: 'Utilizatorul a fost șters!',
            teamDeleted: 'Echipa a fost ștearsă!',
            teamUpdated: 'Echipa a fost actualizată!',
            confirmSeatDeletion:
                'Ești sigur că vrei să ștergi acest utilizator?',
            confirmTeamDeletion: 'Ești sigur că vrei să ștergi acestă echipă?',
            RegisteredUserEmail: 'Email utilizator deja inregistrat...',
            seatsInfo:
                'Puteți invita alți utilizatori la planul dvs. Aceștia trebuie să fie deja înregistrați și trebuie să accepte invitația dvs.',
            signatureInfo:
                'Semnătura configurată aici va fi aleasă automat în momentul semnării unui document. Dacă este nevoie această va putea fi modificată la semnarea documentului.',
            seatInviteAcceptConfirmation:
                'Vă rugăm confirmați acceptarea invitației',
            seatInviteAcceptDeclineConfirmation:
                'Vă rugăm confirmați refuzul invitației',
            invitedBy: 'invitat de',
            Teams: 'Echipe',
            teamsInfo:
                'Documentele trimise vor fi partajate intre membrii echipelor. Echipele pot fi formate doar din utilizatori care au acceptat deja invitatia la planul dvs.',
            memberTeamsTooltip:
                'Documentele trimise de membrii echipelor din care faceți parte vor putea fi vizualizate de întreaga echipă, cu excepția cazului în care se bifează opțiunea de a nu se partaja cu echipa în momentul trimiterii unei cereri de semnare.',
            teamNewRequestNotif: 'Notificare la trimiterea documentelor',
            teamNewRequestNotifTooltip:
                'Veți primi un email de fiecare dată când un alt membru al acestei echipe trimite o nouă cerere de semnare partajată cu echipa.',
            teamNotifUpdated:
                'Setările de notificare ale echipei au fost actualizate!',
            PlanInfo:
                'Dacă doriți să achiziționați licențe pentru mai mulți utilizatori din cadrul companiei, ajustați la checkout câmpul „Cantitate” astfel încât acesta să reflecte numărul total de utilizatori care vor avea acces la platformă. După finalizarea plății, veți putea administra licențele și invita colegii direct din contul dumneavoastră.',
            unverified: 'neverificată',
            EmailNotVerified: 'Indisponibil: Adresă de email neverificată',
            DisableMFAConfirmation:
                'Confirmati dezactivarea 2FA. Veti fi delogat automat si va trebui sa va reautentificati.',
            TwoFAConfigTitle: 'Configurare 2FA (SMS)',
            PhoneNumber: 'Număr de telefon',
            ReenterPassword: 'Reintroduceti parola',
            InputPhoneNumber: 'Numar telefon mobil...',
            SMSCodeTitle: 'Cod SMS',
            SMSCodePh: 'Introduceti codul...',
            twoFaTooltip:
                'Pentru securitate sporita puteti activa autentificarea in doi pasi cu verificare prin SMS',
            apiConfirmation:
                'Activați doar dacă doriți sa dezvoltați o integrare prin API',
            SigTypes: 'Modalități semnare',
            SigTypesInfo:
                'Selectați tipurile de semnătură care vor putea fi alese de catre semnatari.',
            NoSeatsForTeam:
                'Nu aveți niciun scaun ocupat, așadar nu puteți crea echipe. Vă rugăm să adăugați cel puțin un utilizator.',
            packageInfo: 'Informații Pachet',
            packageType: 'Tip Pachet',
            startDate: 'Data Start',
            endDate: 'Data Sfârșit',
            totalRequests: 'Total Cereri',
            usageOverview: 'Prezentare Generală Utilizare',
            totalRequestsSent: 'Total Cereri Trimise',
            userMonthlyStats: 'Statistici Utilizatori',
            requests: 'cereri',
            noEnterprisePackage: 'Nu există pachet enterprise disponibil',
            Permissions: 'Permisiuni',
            hasAdminViewPermissions:
                'Permisiuni de vizualizare a tuturor documentelor organizației',
            Analytics: 'Rapoarte',
            ReportsTitle: 'Rapoarte și statistici',
            reportsInfo:
                'Statistici pentru documentele trimise de tine spre semnare în perioada selectată.',
            viewReports: 'Vezi rapoartele documentelor trimise',
            exportCsv: 'Export CSV',
            csvMaxRange: 'Exportul CSV este disponibil pentru maxim 3 luni',
            reportMaxRange: 'Selectează un interval de maxim 1 an',
            reportsRateLimited:
                'Prea multe cereri de rapoarte. Te rugăm să aștepți un minut și să încerci din nou.',
            csvRateLimited:
                'Poți exporta o dată pe minut. Te rugăm să încerci din nou în curând.',
            noReportData: 'Nu există documente trimise în perioada selectată',
            reportSent: 'Trimise',
            reportCompleted: 'Finalizate',
            reportInProgress: 'În curs',
            reportRejected: 'Respinse',
            reportCanceled: 'Anulate',
            completionRate: 'Rată de finalizare',
            activity: 'Activitate',
            timeToComplete: 'Timp până la finalizare',
            average: 'Medie',
            median: 'Median',
            signersTitle: 'Semnatari',
            signersTotal: 'Total',
            signersSigned: 'Semnate',
            signersPending: 'În așteptare',
            signersRejected: 'Respinse',
            bySource: 'După sursă',
            topRecipients: 'Top semnatari',
            topTags: 'Top etichete',
            noPasswordEmailTitle: 'Schimbă emailul',
            noPasswordEmailMessage:
                'Pentru a schimba adresa de email trebuie mai întâi să îți setezi o parolă. Apasă Confirmă pentru a te deloga și a fi redirecționat la pagina de resetare parolă. După setarea parolei, reloghează-te și schimbă emailul de aici.',
        },
        api: {
            Docs: 'Documentație',
            ApiDocumentation: 'Documentație API',
            LlmPromptTitle: 'Folosești un LLM?',
            LlmPromptDescription: 'Descarcă și folosește direct schema API.',
            DownloadApiSchema: 'Descarcă schema API',
            Usage: 'Consum',
            BuyApiCredits: 'Cumpără credite API',
            ValidTo: 'Valabilitate până la',
            ApiKeys: 'Chei API',
            NotificationEmail: 'Email Notificări',
            NotificationEmailPlaceholder:
                'Email suplimentar pentru notificări consum... (opțional)',
            WebhookUrl: 'URL Webhook',
            WebhookEvents: 'Evenimente',
            HeaderName: 'Nume header',
            HeaderValue: 'Valoare header',
            RevokeApiKey: 'Revocă',
            RegenerateApiKey: 'Regenerează',
            RevokeConfirmation:
                'Ești sigur că vrei să revoci cheia API? Toate cererile care folosesc această cheie vor înceta să funcționeze imediat.',
            RegenerateConfirmation:
                'Ești sigur că vrei să regenerezi cheia API? Cheia curentă va fi revocată și una nouă va fi emisă.',
            ApiKeyRevoked: 'Cheia API a fost revocată cu succes.',
            ApiKeyRegenerated: 'Cheia API a fost regenerată cu succes.',
            ApiKeyGenerated: 'Cheia API a fost generată cu succes.',
            NoApiKey: 'Nicio cheie API activă.',
            ShowKey: 'Arată',
            HideKey: 'Ascunde',
            CopyKeyWarning:
                'Copiați această cheie acum. Nu o veți mai putea vedea din nou.',
            KeyNamePlaceholder: 'Nume cheie...',
            GenerateNewKey: 'Generează',
            MaxKeysReached: 'Numărul maxim de chei API a fost atins (5).',
            Credits: 'Credite',
            credits: 'credite',
            Consumption: 'Consum',
            ShowMonthlyConsumption: 'Arată consumul lunar',
            HideMonthlyConsumption: 'Ascunde consumul lunar',
            NoMonthlyConsumption: 'Nu există încă utilizare API lunară.',
            available: 'disponibile',
            untilMonthEnd: 'până la sfârșitul lunii',
            AutoRefill: 'Reîncărcare automată',
            EnableAutoRefill: 'Activează reîncărcarea automată',
            AutoRefillThresholdPlaceholder:
                'Reîncarcă când creditele scad sub această valoare',
            AutoRefillQuantityPlaceholder:
                'Numărul de credite cumpărate la fiecare reîncărcare',
            AutoRefillThresholdError: 'Trebuie să fie un număr > 0',
            AutoRefillQuantityError: 'Trebuie să fie un număr ≥ 1',
        },
        auth: {
            alreadyRegisteredQ: 'Ai deja cont?',
            emailAddress: 'Adresă email',
            emailInUse: 'Adresă de email existentă',
            forgotPasswordQ: 'Ai uitat parola?',
            inputEmailAddress: 'Introduceți adresa de email...',
            inputName: 'Companie sau persoană fizică...',
            inputPassword: 'Introduceți parola...',
            login: 'Intră in cont',
            loginWithGoogle: 'Continuă cu Google',
            loginWithMSF: 'Continuă cu Microsoft',
            name: 'Nume',
            notRegisteredQ: 'Nu ai cont?',
            password: 'Parolă',
            passwordComplexity: 'Minim 8 caractere',
            register: 'Înregistrează-te',
            registerTitle: 'Încearcă {{app}} gratuit!',
            registerSubTitle:
                'Semnează sau trimite documente spre semnare în doar câteva secunde. 5 documente/lună incluse.',
            registerTitleApiDev: 'Creează un cont pentru API development',
            registerSubTitleApiDev:
                'Creează un cont de dezvoltare cu acces API. Utilizare nelimitată rezonabilă pentru dezvoltare și testare. Documentele vor conține watermark.',
            loginTitle: 'Autentificare {{app}}',
            loginSubTitle:
                'Semnează sau trimite documente spre semnare în doar câteva secunde',
            registerWithGoogle: 'Continuă cu Google',
            registerWithMSF: 'Continuă cu Microsoft',
            tos: 'Termeni și Condiții',
            tosMessage: 'Înregistrându-vă sunteți de acord cu',
            wrongEmailOrPasswords: 'Email sau parola incorecte',
            allRightsReserved: 'Toate Drepturile Rezervate',
            footerMessage: 'Ai orice fel de intrebări? Contactează-ne!',
        },
        bulk: {
            Completed: 'Trimis',
            completedTable: 'Tabel completat',
            completedTableTootlip:
                'Fisierul csv trebuie sa contina capul de tabel descarcat la pasul precedent. Din acest fisier se vor extrage adresele de email sau numerele de telefon ale semnatarilor.',
            createSuccess: 'Trimiterea bulk a fost inregistrata cu succes!',
            csvError: 'Eroare extragere!',
            csvSuccess:
                'Fisierul a fost procesat cu succes! {{number}} cereri valide',
            Date: 'Dată',
            errorRows: 'Rânduri cu erori',
            errorRowsTooltip:
                'Verificati formatul adreselor de email sau a numerelor de telefon. De asemenea, verificati daca aveti duplicate pe acelasi rand.',
            fileTypeErr: 'Fisierul trebuie sa fie .csv',
            instructions: 'Instrucțiuni',
            instructionsIntro: `Trimiterea în bulk permite folosirea unui template
                                pentru a trimite același document către mai mulți
                                semnatari dintr-o singură operațiune. În loc de a
                                introduce adresele de email ale semnatarilor manual la
                                fiecare folosire a template-ului, la trimitere bulk se
                                va încarcă un tabel pre-completat.`,
            instructionsStep1: `Pas 1: Descarcati capul de tabel pus la
                                dispozitie mai jos la sectiunea Cap de tabel. Fiecare
                                coloana corespunde unui semnatar definit in template.`,
            instructionsStep2: `Pas 2: Completati fisierul .csv cu
                                adresele de email sau numerele de telefon ale
                                semnatarilor si salvati ca fisier .csv (puteti folosi de
                                exemplu Google Sheets). Fiecare rand va genera o cerere
                                de semnare separata.`,
            instructionsStep3: `Pas 3: Încărcați fisierul completat
                                folosind sectiunea Tabel completat.`,
            instructionsStep4: `Pas 4: Trimiteti. Cererile de semnare
                                generate vor aparea progresiv in lista Documentelor
                                trimise.`,
            pageTitle: 'Trimite in bulk',
            Sent: 'Trimise',
            sentPageTitle: 'Trimiteri bulk',
            tableHeader: 'Cap de tabel',
            tableHeaderTootltip:
                'Acest fisier contine capul de tabel si trebuie completat de dvs. cu adresele de email sau numerele de telefon ale semnatarilor.',
            Total: 'Cereri individuale',
            uploadCompletedTable: 'Încărcați tabelul completat.',
            uploadCsvFile: 'Încarcă fișier .csv',
            validRows: 'Rânduri valide',
            validRowsTootlip:
                'Aceste randuri sunt valide si vor genera fiecare cate o cerere de semnare individuala.',
        },
        buttons: {
            add: 'Adaugă',
            Back: 'Înapoi',
            backCancel: 'Renunță',
            cancel: 'Anulează',
            cancelRequest: 'Anulează cerere',
            delete: 'Șterge',
            download: 'Descarcă',
            downloadCertificate: 'Descarcă Certificatul',
            DownloadDocument: 'Descarcă Documentul',
            edit: 'Editează',
            extract: 'Extrage',
            manage: 'Gestionează',
            newSignRequest: 'Cerere Nouă',
            save: 'Salvează',
            send: 'Trimite',
            sendBulk: 'Trimite bulk',
            sign: 'Semnează',
            use: 'Folosește',
            Invite: 'Invită',
            Accept: 'Acceptă',
            Decline: 'Refuză',
            CreateNewTeam: 'Creează echipă nouă',
            Setup: 'Configurează',
            Disable: 'Dezactivează',
            SendCode: 'Trimite cod',
            Remind: 'Reamintește',
        },
        common: {
            Account: 'Cont',
            Cancel: 'Renunță',
            checkbox: 'bifă',
            Checkbox: 'Bifă',
            checkboxes: 'bife',
            FileAttachment: 'Fișier',
            fileAttachment: 'fișier',
            fileAttachments: 'fișiere',
            Textarea: 'Paragraf',
            textarea: 'paragraf',
            Textareas: 'Paragrafe',
            textareas: 'paragrafe',
            Date: 'Dată',
            date: 'dată',
            Dates: 'Date',
            dates: 'date',
            Completed: 'Finalizată',
            Close: 'Închide',
            Confirm: 'Confirmă',
            DefaultSignature: 'Semnătură implicită',
            Document: 'Document',
            Documents: 'Documente',
            pagesCount_one: '{{count}} pagină',
            pagesCount_few: '{{count}} pagini',
            pagesCount_other: '{{count}} de pagini',
            Fields: 'Câmpuri',
            genericError:
                'A apărut o eroare. Am fost informați si o vom remedia curând.',
            InProgress: 'În curs',
            mandatory: 'obligatoriu',
            Mandatory: 'Obligatoriu',
            Group: 'Grup',
            GroupID: 'ID Grup',
            Initials: 'Inițiale',
            initials: 'inițiale',
            No: 'Nu',
            onlyWithBusinessPlan: 'Disponibil doar cu planul Business.',
            Options: 'Opțiuni',
            Sentby: 'Trimis de',
            SentBy: 'Trimis De',
            CreatedBy: 'Creat de',
            signature: 'semnătură',
            Signature: 'Semnătură',
            signatures: 'semnături',
            Signer: 'Semnatar',
            Signers: 'Semnatari',
            stamp: 'ștampilă',
            Stamp: 'Ștampilă',
            stamps: 'ștampile',
            Status: 'Stare',
            Tags: 'Etichete',
            text: 'text',
            Text: 'Text',
            texts: 'texte',
            Yes: 'Da',
            Enable: 'Activează',
            Enabled: 'Activ',
            Error: 'Eroare',
            Disabled: 'Dezactivat',
            UpdateSuccess: 'Actualizare efectuata cu succes!',
            Copy: 'Copiază',
            Copied: 'Copiat',
            SingLinkCopySuccess: 'Link-ul de semnare a fost copiat cu sucess!',
            ApiKeyCopySuccess: 'Cheia API a fost copiată cu succes!',
            Reason: 'Motiv',
            Updated: 'Actualizat',
            FontSize: 'Mărime font',
            Certificate: 'Certificat',
            More: 'Mai multe',
            Notifications: 'Notificări',
            Consent: 'Consimțământ semnare',
            Radio: 'Radio',
            Members: 'Membri',
            You: 'tu',
            Name: 'Nume',
            selected: 'selectați',
            Fixed: 'Fixat',
            Reload: 'Reîncarcă',
            Continue: 'Continuă',
            Seen: 'Vizualizat',
            Signed: 'Semnat',
            signedSuffix: 'semnat',
            Rejected: 'Refuzat',
            Downloaded: 'Descărcat',
        },
        createSR: {
            addSigner: 'Adaugă semnatar',
            converting: 'Se convertește la PDF...',
            merging: 'Se combină documentele...',
            duplicateEmail: 'Email duplicat',
            duplicateNumber: 'Număr duplicat',
            emailAddPh: 'Adauga mesaj',
            emailRecipientPh: 'Adresă email semnatar...',
            emailTitle: 'Mesaj (opțional)',
            emailTitleTooltip:
                'Poți transmite un mesaj personalizat semnatarilor. Acesta va fi adăugat la emailul de notificare.',
            emailSubject: 'Subiect email (opțional)',
            emailSubjectTooltip:
                'Poți adăuga un subiect personalizat pentru emailul de notificare. Dacă nu este setat, se va folosi subiectul implicit.',
            extractTagsSuccess: '{{fieldsCount}} campuri au fost extrase!',
            extractTagsZero:
                'Nu a fost gasit niciun camp! Asigurati-va ca aveti tag-uri de forma {{s:1}} sau {{t:1____ }}',
            fieldsMessage:
                'Ai poziționat {{signaturesFieldsCount}} semnături, {{stampFieldsCount}} ștampile și {{textFieldsCount}} câmpuri text.',
            fieldsMessagePrefix: 'Ați poziționat',
            fieldsMinSignersErr: 'Completați cel puțin un semnatar',
            fieldsTitle: 'Poziții semnături sau alte informații (opțional)',
            fieldsTitleTooltip:
                'Puteți indica semnatarilor locurile pe document în care trebuie să semneze sau să completeze diferite informații. De asemenea, puteți genera automat câmpuri dacă adăugați anumite tag-uri în textul documentului. Acestea pot fi de culoare albă pentru a nu fi vizibile. De ex. tag-ul “{{s:1}}” pentru o semnătură a primului semnatar, “{{s:2}}” pentru al doilea semnatar și așa mai departe. Pentru a face câmpul obligatoriu, adăugați litera “r” la finalul tag-ului, ex: “{{s:1}}r”. Pentru a bloca poziția câmpului, adăugați litera “f”, ex: “{{s:1}}f”. Literele pot fi combinate, ex: “{{s:1}}rf”. Alte tag-uri posibile: “{{t:1____}}” pentru câmpuri text, “{{c:1}}” pentru bifă sau “{{c:1:1}}” pentru grupuri de bife, unde al doilea număr din tag reprezintă nr-ul grupului. Un grup de bife obligatoriu va obliga semnatarul să bifeze cel puțin o opțiune. Pentru un grup de bife de tip radio (o singură opțiune selectabilă), adăugați litera “o” la final, ex: “{{c:1:1}}o”. În plus, se pot extrage și semnatarii cu tag-uri de forma: {{r:1:e:email@exemplu.com}} sau {{r:1:p:0723123123}}. Acestea pot fi de culoare alba pentru a nu fi vizibile.',
            fileSizeErr: 'Fisierul depăseste mărimea maximă de',
            fileTypeErr: 'Fisierul trebuie sa fie pdf, doc sau docx',
            incorectEmail: 'Email incorect',
            incorectNumber: 'Număr incorect',
            isCopyOnly: 'Trimite doar copie',
            isCopyOnlyTooltip:
                'Recipientul doar va primi o copie a documentului semnat. Acesta nu va putea semna.',
            leftChars: 'caractere rămase',
            templates: 'Șabloane',
            emailTemplatesSubject: 'Șabloane subiect email',
            emailTemplatesMessage: 'Șabloane mesaj email',
            myTemplates: 'Șabloanele mele',
            teamTemplates: 'Șabloane echipă',
            noTemplates: 'Nu există șabloane salvate.',
            saveCurrentAsTemplate: 'Salvează textul curent ca șablon',
            noContentToSave: 'Scrieți ceva mai întâi pentru a salva ca șablon',
            shareWithTeams: 'Partajează cu echipa',
            MinNameChars: 'Minim {{number}} caractere',
            moreSignerWithBusiness:
                'Mai mulți semnatari disponibili doar cu planul Business',
            noFieldsMessage: 'Nu ați poziționat nici un câmp.',
            oneClickSign: 'Semnare cu un click',
            advancedSignature: 'Semnare avansată cu OTP',
            optVerification: 'Semnare avansată cu OTP',
            optVerificationTooltip:
                'Cu această opțiune, semnatarului i se va solicita și verificarea numărului de telefon mobil printr-un cod OTP trimis prin SMS.',
            oneClickSignTooltip:
                'Se foloseste impreună cu notificarea prin SMS si indicarea locului de semnare pe document. Semnatarul va trebui doar să atingă locul indicat de dvs. si acesta se va completa automat cu numele semnatarului.',
            EnglishLanguage: 'Limba engleză',
            SignLinkOnly: 'Doar link semnare',
            SignLinkOnlyTootlip:
                'Puteți folosi această opțiune dacă semnatarul semnează de la acelasi calculator ca dvs. sau dacă doriți să furnizați dvs. link-ul de semnare pe alte canale cum ar fi Whatsapp. După trimitere, deschideți detaliile cererii si veti găsi in dreptul semnatarului link-ul unic de semnare.',
            SendBySMS: 'SMS',
            EnglishLanguageTooltip:
                'Notificarile email si pagina de semnare vor fi in limba engleză',
            prefillInfoBubble1:
                'Poți folosi această pagină pentru a adăuga pe document diverse date sau informații.',
            prefillInfoBubble2:
                'Acestea vor fi aplicate permanent pe document in momentul trimiterii lui spre semnare și nu vor mai putea fi modificate ulterior.',
            prefillMessage: 'Ați adăugat {{number}} texte.',
            prefillPageTitle: 'Pre-completează documentul',
            prefillTitle: 'Pre-completare date (opțional)',
            prefillTitleTootlip:
                'Poți adăuga date si informații pe document înainte de trimitere.',
            SelectSigner: 'Alege semnatarul',
            sentSuccess: 'Cererea a fost trimisa cu succes!',
            SignerNamePh: 'Nume semnatar...',
            signInOrder: 'Semnează în ordine',
            signInOrderTooltip:
                'Semnatarii vor primi pe rând documentul în ordinea adăugării lor.',
            signMySelf: 'Semnez și eu',
            signMyselfTooltip:
                'Vei fi adăugat în lista de semnatari și vei putea semna direct în aplicație după trimitere.',
            smsNotifOption: 'Trimite prin SMS',
            smsNotifOptionTooltip:
                'Semnatarul va primi prin SMS link-ul de semnare a documentului si va putea semna direct pe telefonul mobil. Se poate folosi această opțiune pentru semnatarii care nu au adresă de email.',
            tagsAddPh: 'Adaugă una sau mai multe etichete...',
            tagsTitle: 'Etichete (opțional)',
            tagsTitleTooltip:
                'Poți folosi etichete personalizate pentru a organiza cererile pe diferite categorii.',
            templateRecipientPh: 'Ex. Client, Părinte, Proprietar, etc...',
            templateSaveSuccess: 'Template-ul a fost salvat cu succes!',
            uploadDoc: 'Încărcați un document',
            uploadErr: 'A aparut o eroare la incarcarea documentului.',
            mergedFileTooLarge:
                'Documentul combinat ar depăși 5MB. Vă rugăm adăugați un fișier mai mic.',
            uploadFile: 'Încarcă fișier',
            addFile: 'Adaugă fișier',
            dragToReorder: 'Trage pentru a reordona',
            mainDocument: 'Document principal',
            additionalDocuments: 'Documente adiționale',
            additionalDocumentsTooltip:
                'Aceste documente vor fi trimise în cadrul aceleiași cereri de semnare. Insă, după finalizarea cererii, fiecare document poate fi descărcat separat.',
            pickFromDrive: 'Google Drive',
            driveDownloading: 'Se descarcă din Google Drive...',
            driveErr: 'Fișierul nu a putut fi importat din Google Drive.',
            driveAuthErr:
                'Accesul la Google Drive nu a fost acordat. Vă rugăm încercați din nou și permiteți accesul.',
            verifyEmail:
                'Pentru a trimite mai multe documente vă rugam confirmați-vă adresa de email prin accesarea link-ului de confirmare din emailul primit la inregistrare.',
            freePlanMonthlyLimitReached:
                'Ați atins limita planului gratuit: puteți trimite cel mult 5 documente pe lună. Faceți upgrade pentru a continua.',
            hideFromTeam: 'Nu partaja cu echipa',
            hideFromTeamTooltip:
                'Documentul nu va fi vizibil pentru ceilalți membri ai echipei.',
        },
        editFields: {
            fieldLabel: 'Titlu (opțional)',
            textFieldDescriptionPh: 'Ex. Nume, Data, Adresa email...',
            fileAttachFieldDescriptionPh: 'Ex. ID, Certificat, etc...',
            howToDrag: 'Țineți apăsat si trageți câmpul direct pe document',
            infoBubble1:
                'Câmpurile adăugate pe această pagina vor fi completate de către semnatari după trimiterea documentului.',
            infoBubble2:
                'După adăugarea sau selectarea unui câmp veți putea aloca semnatarul.',
            infoBubble3: 'Ați poziționat {{fieldModeFieldsCount}} câmpuri.',
            infoBubble4:
                'Toate câmpurile au un semnatar alocat. Puteți salva pozițiile.',
            infoBubble5:
                '{{noRecipientFieldsCount}} câmpuri nu au semnatar alocat.',
            infoBubble6:
                'Țineți apăsat si trageți câmpul pe document. Alocați semnatarul din panoul din dreapta.',
            infoBubble7:
                'Semnatarul nu va putea finaliza semnarea documentului dacă nu completează acest câmp.',
            infoBubble8:
                'Acest câmp va putea fi completat de semnatarul selectat mai sus după trimiterea cererii.',
            infoBubble9:
                'O descriere scurtă îi poate indica semnatarului tipul de informație de completat.',
            infoBubble10:
                'Un grup de bife obligatoriu va obliga semnatarul să bifeze cel puțin o opțiune.',
            infoBubble11:
                'Un grup de tip radio va permite semnatarului să aleagă o singură opțiune din grup.',
            infoBubble12:
                'Un câmp fixat nu poate fi mutat sau redimensionat de semnatar.',
            inputTextPh: 'Text...',
            noSignerFields: 'Aveți câmpuri fără semnatar',
            title: 'Indică locurile semnăturilor',
        },
        homePage: {
            subTitle: 'Aici găsești sumarul documentelor trimise și primite',
        },
        menu: {
            account: 'CONT',
            bulkSent: 'Trimiteri Bulk',
            contact: 'Contact',
            free: 'gratuit',
            home: 'Acasă',
            logout: 'Deloghează-te',
            myAccount: 'Contul Meu',
            newRequest: 'Cerere Nouă',
            personalPlan: 'Plan Personal',
            receivedRequests: 'Cereri Primite',
            reports: 'Rapoarte',
            sentDocs: 'Documente Trimise',
            templates: 'Template-uri',
            upgrade: 'UPGRADE',
            userGuide: 'Ghid Utilizare',
        },
        recipientStatus: {
            [RecipientStatus.SIGNED]: 'Semnat',
            [RecipientStatus.PENDING]: 'Nesemnat',
            [RecipientStatus.NEXT]: 'La rând',
            [RecipientStatus.WAITING]: 'Așteaptă rândul',
            [RecipientStatus.SIG_RECEIVED]: 'Procesare',
            [RecipientStatus.SMS_ERROR]: 'Eroare SMS',
            [RecipientStatus.REJECTED]: 'Refuzat',
        },
        recipientStatusTitle: {
            [RecipientStatus.SIGNED]: 'Semnatarul a semnat.',
            [RecipientStatus.PENDING]: 'Semnatarul nu a semnat încă.',
            [RecipientStatus.NEXT]: 'Este rândul acestul semnatar sa semneze.',
            [RecipientStatus.WAITING]: 'Așteaptă rândul',
            [RecipientStatus.SIG_RECEIVED]: 'Se aplică semnatura pe document.',
            [RecipientStatus.SMS_ERROR]:
                'Trimiterea SMS-ului catre aceste semnatar nu a reusit.',
            [RecipientStatus.REJECTED]: 'Semnatarul a refuzat semnarea.',
        },
        requestDetails: {
            additionalFiles: 'Fișiere adiționale',
            FileAttachments: 'Fișiere semnatari',
            completedDate: 'Dată Finalizare',
            copyOnlySigners: 'Copie document semnat',
            Loading: 'Se actualizează...',
            NotYetPossible: 'Nu este încă posibil',
            reminder: 'Reamintire',
            reminderSuccessMessage:
                'Notificarea de reamintire a fost trimisă cu succes!',
            Send: 'Trimite',
            sentBy: 'Trimis de',
            sentDate: 'Dată Trimitere',
            SuccessfullySent: 'Trimisă cu succes',
            tooltipMessage1:
                'Puteți trimite o notificare de reamintire o data pe zi.',
            tooltipMessage2:
                'Se vor trimite copii ale documentului semnat si la aceste adrese de email',
            cancelConfirmation:
                'Vă rugăm confirmați anularea cererii de semnare',
            deleteConfirmation:
                'Vă rugăm confirmați ștergerea cererii de semnare',
        },
        requestsListPage: {
            Details: 'Detalii',
            Document: 'Document',
            mainButtonTitleRequest: 'Cerere nouă',
            mainButtonTitleTemplate: 'Template nou',
            No: 'Nu',
            noRequestFound: 'Nu s-a găsit nici o cerere.',
            noTemplateFound: 'Nu s-a găsit nici un template.',
            SentDate: 'Dată trimitere',
            Sign: 'Semnează',
            Status: 'Stare',
            templateInfoText: `Template-urile permit salvarea unei cereri de semnătură -
                                                                                document, semnatari, poziții semnături, etc - ca șablon
                                                                                predefinit. Acesta va putea fi refolosit ori de câte ori
                                                                                este nevoie.`,
            Waiting: 'În ordine',
            YouSigned: 'Ai semnat',
            TemplateDeleteConfirmation:
                'Va rugam confirmati stergerea template-ului',
            RemindersSent: 'Reamintiri trimise',
            ConfirmUpdateRecipient:
                'Va rugam confirmati modificarea semnatarului',
        },
        requestStatus: {
            [RequestStatus.COMPLETED]: 'Finalizată',
            [RequestStatus.IN_PROGRESS]: 'În curs',
            [RequestStatus.PROCESSING]: 'În Procesare',
            [RequestStatus.PREFILLING]: 'În Procesare',
            [RequestStatus.CANCELED]: 'Anulată',
            [RequestStatus.TEMPLATE]: 'Template',
            [RequestStatus.REJECTED]: 'Refuzată',
        },
        requestStatusTitle: {
            [RequestStatus.COMPLETED]:
                'Toti semnatarii au semnat acest document.',
            [RequestStatus.IN_PROGRESS]:
                'In asteparea semnăturilor solicitate.',
            [RequestStatus.PROCESSING]:
                'Se aplică semnătura. Verificati starea in cateva minute.',
            [RequestStatus.PREFILLING]: 'Verificati starea in cateva minute.',
            [RequestStatus.CANCELED]: 'Cererea a fost anulată',
            [RequestStatus.TEMPLATE]: 'Sablon',
            [RequestStatus.REJECTED]: 'Cererea a fost refuzată',
        },
        routes: {
            AccountPageTitle: 'Contul meu',
            AccountRoute: '/account',
            ApiPageTitle: 'Setări API',
            ApiRoute: '/api-config',
            BulkSendCreatePageTitle: 'Creează cerere bulk',
            BulkSendCreateRoute: '/bulk/create',
            BulkSentPageTitle: 'Cereri trimise in bulk',
            BulkSentRoute: '/bulk',
            CreateFromTemplatePageTitle: 'Creează cerere',
            CreateFromTemplateRoute: '/cereri/from-template',
            CreateRequestPageTitle: 'Creează cerere',
            CreateRequestRoute: '/cereri/noua',
            CreateTemplate: '/templates/noua',
            CreateTemplatePageTitle: 'Creează template',
            CreateTemplateRoute: '/templates/noua',
            EditFieldsPageTitle: 'Indică locurile semnăturilor',
            EditFieldsRoute: '/cereri/noua/semnaturi',
            EditTemplatePageTitle: 'Editează template',
            EditTemplateRoute: '/templates/edit',
            EmailVerificationPageTitle: 'Verificare email',
            EmailVerificationRoute: '/email/verify',
            EmailChangeConfirmationPageTitle: 'Confirmare schimbare email',
            EmailChangeConfirmationRoute: '/email/change-confirm',
            HomePageTitle: 'Acasă',
            HomeRoute: '/acasa',
            LoginPageTitle: 'Login',
            LoginRoute: '/login',
            PreFillDocumentPageTitle: 'Pre-completează documentul',
            PreFillDocumentRoute: '/cereri/noua/prefill',
            ReceivedRequestsPageTitle: 'Cereri primite',
            ReceivedRequestsRoute: '/cereri/primite',
            ReportsPageTitle: 'Rapoarte și statistici',
            ReportsRoute: '/reports',
            ResetPasswordPageTitle: 'Resetează parola',
            ResetPasswordRoute: '/reseteaza-parola',
            SentRequestsPageTitle: 'Documente trimise',
            SentRequestsRoute: '/cereri/trimise',
            SignErrorPageTitle: 'Eroare semnare',
            SignErrorRoute: '/eroare-semnare',
            SignPageTitle: 'Semnează',
            SignRoute: '/semneaza',
            SignSuccessPageTitle: 'Succes semnare',
            SignSuccessRoute: '/succes-semnare',
            SignupPageTitle: 'Înregistrare',
            SignupRoute: '/signup',
            SuperRoute: '/super',
            TemplatesPageTitle: 'Template-uri',
            TemplatesRoute: '/templates',
            CompletedDocumentRoute: '/document/completed',
            CompletedDocumentPageTitle: 'Descărcare document semnat',
        },
        search: {
            searchPh: 'Caută un document...',
            selectFilters: 'Alege filtre...',
            selectTimeRange: 'Selectează perioada...',
            typeToSearch: 'Tastează pentru a căuta...',
            noResults: 'Niciun rezultat',
        },
        sign: {
            AlreadySigned: 'Ați semnat deja acest document.',
            andFill: 'și de completat {{nonSigsCount}} câmpuri',
            Check: 'Bifează',
            closeWindow: 'Puteți inchide fereastra.',
            createAccount: 'Creează cont',
            createAccountCTA: `Creează-ți cont pentru a putea administra si vedea istoricul
                                documentelor semnate.`,
            docHasBeenSigned: 'Documentul a fost semnat cu',
            docSentByEmail: `Veți primi documentul semnat de catre toți semnatarii la adresa dvs. de email sau prin SMS.
                                De asemenea, cu un cont gratuit puteți administra si
                                vedea istoricul documentelor semnate.`,
            Draw: 'Desenează',
            Generator: 'Generator',
            error: 'eroare',
            errorEncountered: 'Semnarea a întâmpinat o',
            extraFields: 'Extra câmpuri',
            DeclinedErr: 'Cererea de semnare a fost refuzată',
            EmailNotVerifiedErr:
                'Pentru a semna vă rugăm verificați-vă adresa de email.',
            LinkExpired:
                'Link-ul de semnare a expirat. Vă rugăm să solicitați expeditorului să retrimită.',
            GoToField: 'Mergi la poziția',
            imageFileErr: 'Fisierul trebuie sa fie png, jpg sau jpeg.',
            fileSizeErr: 'Fisierul depaseste marimea maxima de {{maxMB}}MB',
            fileAttachExtErr:
                'Fisierul trebui sa fie de tip document, imagine sau zip',
            infoBubble1: 'Apăsați pe zona indicată pentru a semna.',
            infoBubble2: 'Țineți apăsat si trageți câmpul direct pe document.',
            infoBubble3:
                'Faceți click pe zona indicată pentru a semna sau completa.',
            InputName: 'Introduceți numele...',
            InputText: 'Introduceți textul...',
            InvalidSigner: 'Nu ai dreptul de a semna acest document.',
            NotFound: 'Cererea nu a fost gasită.',
            RequestCanceled: 'Cererea a fost anulată.',
            RequestCompleted: 'Cererea a fost deja finalizată.',
            Reset: 'Resetează',
            SeeDetails: 'Vezi detalii',
            select: 'Alege',
            SignerNotNext: 'Nu sunteți incă la rand pentru a semna.',
            signSuccess: 'Documentul a fost semnat cu succes.',
            signDecline: 'Semnarea a fost refuzată',
            signSuccessMessage:
                'Veți primi documentul semnat de către toți semnatarii la adresa dvs. de email sau prin SMS.',
            signSuccessMessage2: ' Creeaza-ți cont sau află mai multe pe',
            sigTitle: 'Alege tipul de semnătura',
            fileAttachmentTitle: 'Încarcă un fisier',
            successfully: 'success',
            textTitle: 'Adaugă text',
            UnCheck: 'Debifează',
            Uploadimage: 'Încarcă imagine',
            youHaveToSign: 'Aveți de semnat în {{sigsCount}} locuri',
            reviewAndComplete:
                'Vă rugăm să revizuiți documentul de mai jos și să completați câmpurile evidențiate.',
            requiredProgress:
                '{{completed}} din {{total}} câmpuri obligatorii completate',
            allRequiredDone:
                'Toate câmpurile obligatorii sunt completate. Apăsați „{{action}}” pentru a finaliza.',
            Start: 'Începe',
            Next: 'Următorul',
            TagSign: 'Semnează',
            TagFill: 'Completează',
            TagDate: 'Dată',
            TagCheck: 'Bifează',
            TagUpload: 'Încarcă',
            SignHere: 'Semnează aici',
            DeclineConfirmation:
                'Vă rugăm adăugați motivul refuzului și confirmați',
            OtpVerifiedNumber: 'Numar telefon verificat: ',
            OtpVerifiedRecipientsTitle: 'Semnare avansată',
            DrawHint: 'Desenează-ți semnătura deasupra',
            OtpModalTitle: 'Verificare suplimentară',
            OtpModalSubtitle:
                'Emitentul documentului a solicitat o verificare suplimentară a semnatarului. Vă rugăm să introduceți numărul dvs. de telefon mobil și să validați codul OTP primit prin SMS sau WhatsApp.',
            OtpModalSubtitlePresetNumber:
                'Emitentul documentului a solicitat o verificare suplimentară a semnatarului și a indicat numărul dvs. de telefon mobil. Vă rugăm să validați codul OTP primit prin SMS sau WhatsApp.',
            OtpSendCode: 'Trimite cod OTP',
            OtpSmsCode: 'Cod SMS',
            OtpWhatsappCode: 'Cod WhatsApp',
            OtpChannelLabel: 'Trimite codul prin',
            OtpChannelSms: 'SMS',
            OtpChannelWhatsapp: 'WhatsApp',
            OtpSendError: 'Eroare la trimiterea codului OTP!',
            OtpVerifyError: 'Eroare la verificarea codului OTP!',
            OtpExpiredError:
                'Codul OTP a expirat. Vă rugăm să solicitați un cod nou.',
            OtpMaxAttemptsError:
                'Prea multe încercări eșuate. Vă rugăm să solicitați un cod nou.',
            OtpInvalidCodeError:
                'Codul introdus este incorect. Mai aveți {{remaining}} încercări.',
            OtpRateLimitError:
                'Prea multe cereri. Vă rugăm să așteptați un moment și să încercați din nou.',
            OtpSessionExpiredError:
                'Sesiunea de semnare a expirat. Vă rugăm să reîncărcați pagina.',
            sessionExpired:
                'Sesiunea de semnare a expirat. Vă rugăm să reîncărcați pagina pentru a începe o sesiune nouă.',
            consentAgree: 'Sunt de acord cu',
            ConsentTitle:
                'În continuare veți vizualiza și veți putea semna documentul ',
            termsAndConditions: 'Termeni şi Politici',
        },
        summary: {
            noReceivedRequest: 'Nu ai nici o cerere de semnătură primită.',
            noSentRequest:
                'Obține semnăturile de care ai nevoie rapid si sigur.',
            receivedTitle: 'Sumar cereri primite',
            secondaryTitle: 'Vizualizează Detalii',
            sentTitle: 'Sumar documente trimise',
            verifyEmail:
                'Verificați-vă adresa de email pentru a putea vizualiza cererile de semnătură primite',
        },
        other: {
            completedDocumentTitle: 'Descărcați documentul finalizat',
            completedDocumentSubTitle:
                'Documentul a fost semnat cu succes și poate fi descărcat aici:',
            linkExpired: 'Link expirat!',
            linkExpiredMessage:
                'Link-ul de descărcare a expirat. Vă rugăm să solicitați documentul de la expeditor sau să vă creați un cont.',
            documentLoadError: 'Eroare la încărcarea documentului',
            documentDownloadError: 'Eroare la descărcarea documentului',
            certificateDownloadError: 'Eroare la descărcarea certificatului',
        },
    },
};

export { translations };
